import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { Box } from '@cad-arc';
import { TabSubtitle } from '../../../../panels/entity-panels/tabs/tab-subtitle';
import { PropertyBaseKey } from '../types';
import { EventPanelFormPropertyFields } from './event-panel-form-property-fields';
import { EventPanelFormArrayCount } from '../../../tabs/components/event-panel-form-array-count';

export type EventPanelFormPropertyBoxProps = {
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelOptions: EventPanelOptions;
    showTitle?: boolean;
    baseKey: PropertyBaseKey;
    propertyLabel: string;
    noMembersText?: string;
    addButtonText?: string;
    hideDexFields?: boolean;
} & (
    | {
          allowMembersControl: true;
          addButtonText: string;
      }
    | {
          allowMembersControl?: false;
      }
);

export function InvolvedPropertyBox({
    eventForm,
    baseKey,
    propertyLabel,
    noMembersText,
    addButtonText,
    eventPanelOptions,
    allowMembersControl,
    hideDexFields,
}: EventPanelFormPropertyBoxProps): React.ReactElement {
    const addText = addButtonText ? addButtonText : '';
    return (
        <Box pt={baseKey === 'firearms' ? 0 : 4}>
            <TabSubtitle>
                {propertyLabel} (<EventPanelFormArrayCount name={baseKey} />)
            </TabSubtitle>
            <EventPanelFormPropertyFields
                displayAsCards
                form={eventForm}
                eventPanelOptions={eventPanelOptions!}
                hideDexFields={hideDexFields}
                allowMembersControl={allowMembersControl}
                baseKey={baseKey}
                addButtonText={addText}
                noMembersText={noMembersText}
            />
        </Box>
    );
}
